module.exports = __webpack_public_path__ + "images/category_lp/macbook/assessment_achievements/4@2x_79a4478dfbc49988aad4bca2cc993efa.png";